import React, { useState } from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // const categories = [
    //   "Health",
  //   "Legal",
  //   "Education",
  //   "Jobs",
  //   "Business",
  //   "Finance",
  //   "Housing",
  //   "Family",
  //   "Fashion",
  //   "Community",
  // ];
  
  const menuItems = [
    { label: "Home", to: "/" },
    { label: "Our Services", to: "/our-services" },
    // {
    //   label: "Help Categories",
    //   dropdown: true,
    //   isSimple: true, // ✅ Indicates items are strings (not objects)
    //   list: categories,
    //   basePath: "/help", // ✅ Prepend this to string-based links
    // },
    { label: "Advertisers", to: "/advertising-portal" },
    { label: "Franchise", to: "/franchise-page" },
    {
      label: "About Us",
      dropdown: true,
      list: [
        // { name: "Roshelle Czar", to: "/roshelle-czar" },
        { name: "Women of the World, Inc.", to: "/women-of-the-world" },
        { name: "Pink Help", to: "/pink-help" },
        { name: "About This Page", to: "/about-this-page" },
      ],
    },
    { label: "Contact", to: "/contact" },
    { label: "Login / Join", to: "/login" },
  ];

  return (
    <nav className="bg-white shadow-lg fixed top-0 left-0 w-full z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <Link to="/">
            <h1 className="text-2xl font-bold text-gray-800 uppercase font-aeonik">
              Pink Help
            </h1>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-6">
            {menuItems.map((item, index) =>
              item.dropdown ? (
                <div key={index} className="relative group">
                  <span className="text-sm text-gray-700 hover:text-main-green font-medium cursor-pointer">
                    {item.label}
                  </span>
                  <div className="absolute left-0 mt-2 w-56 bg-white rounded-md shadow-lg z-50 opacity-0 group-hover:opacity-100 invisible group-hover:visible transition-all duration-200">
                    <ul className="py-2">
                      {item.list.map((subItem, subIndex) => {
                        const to = item.isSimple
                          ? `${item.basePath}/${subItem.toLowerCase()}`
                          : subItem.to;

                        const label = item.isSimple ? subItem : subItem.name;

                        return (
                          <li key={subIndex} className="px-4 py-2 hover:bg-gray-100">
                            <Link
                              to={to}
                              className="block text-sm text-gray-700 hover:text-main-green"
                            >
                              {label}
                            </Link>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
              ) : (
                <Link
                  key={index}
                  to={item.to}
                  className="text-sm text-gray-700 hover:text-main-green font-medium"
                >
                  {item.label}
                </Link>
              )
            )}
          </div>

          {/* Mobile Toggle */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 focus:outline-none"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Dropdown */}
      {isMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 py-4 px-4 space-y-2">
          {menuItems.map((item, index) =>
            item.dropdown ? (
              <div key={index}>
                <span className="block w-full text-left text-sm text-gray-700 font-medium">
                  {item.label}
                </span>
                <ul className="pl-4 mt-2">
                  {item.list.map((subItem, subIndex) => {
                    const to = item.isSimple
                      ? `${item.basePath}/${subItem.toLowerCase()}`
                      : subItem.to;
                    const label = item.isSimple ? subItem : subItem.name;

                    return (
                      <li key={subIndex} className="py-1 text-sm">
                        <Link
                          to={to}
                          className="text-gray-700 hover:text-main-green"
                          onClick={() => setIsMenuOpen(false)}
                        >
                          {label}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
            ) : (
              <Link
                key={index}
                to={item.to}
                className="block text-sm text-gray-700 hover:text-main-green font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                {item.label}
              </Link>
            )
          )}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
